/**
 * @generated SignedSource<<8cacb74171e91f55c04e520cd846624e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightProvider = "KIWI" | "WAAVO";
export type FlightsProvider = "KIWI" | "WAAVO";
export type SmtpType = "NONE" | "SSL" | "TLS";
export type UpdateSettingsInput = {
  abandonedCheckoutTimeout?: number | null;
  adminEmailErrors?: string | null;
  adminEmailNewsSubscribers?: string | null;
  adminEmailOrders?: string | null;
  advancePayment?: number | null;
  autosaveDelay?: number | null;
  cancelOrdersAfterMinutes?: number | null;
  debugMode?: boolean | null;
  defaultTransferPrice?: number | null;
  descriptionTitle?: string | null;
  durationRanges?: ReadonlyArray<IntRangeInput> | null;
  etg?: EtgSettingsInput | null;
  facebookAppId?: string | null;
  facebookSettings?: FacebookSettingsInput | null;
  flightBookingEnabled?: boolean | null;
  flightsApiLimit?: number | null;
  flightsProvider?: FlightsProvider | null;
  flightsProviderSettings?: ReadonlyArray<FlightsProviderSettingsInput> | null;
  flightsUpdaterEnabled?: boolean | null;
  google?: GoogleSettingsInput | null;
  inactiveUpdaterWarningThreshold?: number | null;
  infantTripPrice?: number | null;
  keepFlightPriceHistoryDays?: number | null;
  notesTitle?: string | null;
  orderCleanupAge?: number | null;
  paysera?: PayseraSettingsInput | null;
  priceChangeTreshold?: number | null;
  priceCheckerLimit?: number | null;
  profiler?: boolean | null;
  revalidateStaticContent?: number | null;
  schemaProviderDetails?: SchemaProviderDetailsInput | null;
  scoro?: ScoroSettingsInput | null;
  seoHomeMetaDescription?: string | null;
  seoHomeTitle?: string | null;
  smtpEmail?: string | null;
  smtpName?: string | null;
  smtpPassword?: string | null;
  smtpPort?: number | null;
  smtpServer?: string | null;
  smtpType?: SmtpType | null;
  smtpUser?: string | null;
  standardMarkupAdult?: number | null;
  standardMarkupChild?: number | null;
  titleSuffix?: string | null;
  tripsH1?: string | null;
  tripsMetaDescription?: string | null;
  tripsMetaTitle?: string | null;
  updateFlightsPerMinute?: number | null;
};
export type IntRangeInput = {
  end: number;
  start: number;
};
export type SchemaProviderDetailsInput = {
  address?: string | null;
  city?: string | null;
  country?: string | null;
  image?: string | null;
  logo?: string | null;
  name?: string | null;
  phone?: string | null;
  postcode?: string | null;
  pricerange?: string | null;
};
export type FlightsProviderSettingsInput = {
  apiKey?: string | null;
  baseUri?: string | null;
  flightsProvider: FlightProvider;
  searchParams?: ReadonlyArray<KeyValuePairInput> | null;
  testMode?: boolean | null;
};
export type KeyValuePairInput = {
  key: string;
  value?: string | null;
};
export type FacebookSettingsInput = {
  accessToken?: string | null;
  loginAppId?: string | null;
  loginAppSecret?: string | null;
  pixelId?: string | null;
  testCode?: string | null;
};
export type EtgSettingsInput = {
  fullLogContext?: boolean | null;
  incrementalBatchSize?: number | null;
  incrementalImport?: boolean | null;
  key?: string | null;
  keyId?: string | null;
  maxRateUpdateFrequency?: number | null;
  rateUpdatesEnabled?: boolean | null;
};
export type PayseraSettingsInput = {
  acceptUrl?: string | null;
  callbackUrl?: string | null;
  cancelUrl?: string | null;
  currency?: string | null;
  lang?: string | null;
  password?: string | null;
  paytext?: string | null;
  projectId?: string | null;
};
export type GoogleSettingsInput = {
  analyticsId?: string | null;
  apiKey?: string | null;
  loginClientId?: string | null;
  loginClientSecret?: string | null;
};
export type ScoroSettingsInput = {
  apiKey?: string | null;
  apiUrl?: string | null;
  ownerId?: number | null;
};
export type SettingsGeneralPageMutation$variables = {
  input: UpdateSettingsInput;
};
export type SettingsGeneralPageMutation$data = {
  readonly updateSettings: {
    readonly " $fragmentSpreads": FragmentRefs<"GeneralSettingsEditForm_settings">;
  };
};
export type SettingsGeneralPageMutation = {
  response: SettingsGeneralPageMutation$data;
  variables: SettingsGeneralPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsGeneralPageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Settings",
        "kind": "LinkedField",
        "name": "updateSettings",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GeneralSettingsEditForm_settings"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsGeneralPageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Settings",
        "kind": "LinkedField",
        "name": "updateSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "standardMarkupAdult",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "standardMarkupChild",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "infantTripPrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "advancePayment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultTransferPrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "descriptionTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notesTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntRange",
            "kind": "LinkedField",
            "name": "durationRanges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "start",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "end",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revalidateStaticContent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelOrdersAfterMinutes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autosaveDelay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceCheckerLimit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adminEmailErrors",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adminEmailNewsSubscribers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adminEmailOrders",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "abandonedCheckoutTimeout",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "orderCleanupAge",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "smtpName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "smtpEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "smtpServer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "smtpPort",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "smtpUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "smtpPassword",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "smtpType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seoHomeTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seoHomeMetaDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "titleSuffix",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tripsMetaTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tripsMetaDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tripsH1",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookAppId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SchemaProviderDetails",
            "kind": "LinkedField",
            "name": "schemaProviderDetails",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "image",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pricerange",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postcode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logo",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flightsProvider",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flightsApiLimit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceChangeTreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flightsUpdaterEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flightBookingEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updateFlightsPerMinute",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "keepFlightPriceHistoryDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inactiveUpdaterWarningThreshold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "debugMode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profiler",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "68f0fa4e944904504b183f6f53d5332f",
    "id": null,
    "metadata": {},
    "name": "SettingsGeneralPageMutation",
    "operationKind": "mutation",
    "text": "mutation SettingsGeneralPageMutation(\n  $input: UpdateSettingsInput!\n) {\n  updateSettings(input: $input) {\n    ...GeneralSettingsEditForm_settings\n  }\n}\n\nfragment GeneralSettingsEditForm_settings on Settings {\n  standardMarkupAdult\n  standardMarkupChild\n  infantTripPrice\n  advancePayment\n  defaultTransferPrice\n  descriptionTitle\n  notesTitle\n  durationRanges {\n    start\n    end\n  }\n  revalidateStaticContent\n  cancelOrdersAfterMinutes\n  autosaveDelay\n  priceCheckerLimit\n  adminEmailErrors\n  adminEmailNewsSubscribers\n  adminEmailOrders\n  abandonedCheckoutTimeout\n  orderCleanupAge\n  smtpName\n  smtpEmail\n  smtpServer\n  smtpPort\n  smtpUser\n  smtpPassword\n  smtpType\n  seoHomeTitle\n  seoHomeMetaDescription\n  titleSuffix\n  tripsMetaTitle\n  tripsMetaDescription\n  tripsH1\n  facebookAppId\n  schemaProviderDetails {\n    name\n    image\n    pricerange\n    phone\n    address\n    city\n    country\n    postcode\n    logo\n  }\n  flightsProvider\n  flightsApiLimit\n  priceChangeTreshold\n  flightsUpdaterEnabled\n  flightBookingEnabled\n  updateFlightsPerMinute\n  keepFlightPriceHistoryDays\n  inactiveUpdaterWarningThreshold\n  debugMode\n  profiler\n}\n"
  }
};
})();

(node as any).hash = "7561d5cb89ee78a39fdc7575b413485b";

export default node;
